function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@okee-uikit/react-hooks';
import { addClass, getPrefixedStyleKey, removeClass } from '@okee-uikit/react-hooks';
import { AnimateEvents, getAnimationValues, getTransitionValues } from '../util';
export var animationPlayStateKeys = getPrefixedStyleKey('animationPlayState');
export var Animation = function (_Emitter) {
  _inherits(Animation, _Emitter);

  var _super = _createSuper(Animation);

  function Animation() {
    var _this;

    _classCallCheck(this, Animation);

    _this = _super.apply(this, arguments);
    _this.type = 'animation';
    _this.ele = null;
    _this.timeout = true;
    _this.maxTimeCost = Infinity;
    return _this;
  }

  _createClass(Animation, [{
    key: "updateOptions",
    value: function updateOptions(options) {
      var _a, _b;

      this.activeClassName = options.activeClassName;
      this.presetClassName = options.presetClassName;
      this.validKeyframes = options.validKeyframes;
      this.validProperty = options.validProperty;
      this.validTarget = options.validTarget;
      this.timeout = (_a = options.timeout) !== null && _a !== void 0 ? _a : true;
      this.type = (_b = options.type) !== null && _b !== void 0 ? _b : 'animation';
    }
  }, {
    key: "setEle",
    value: function setEle(ele) {
      this.ele = ele;
    }
  }, {
    key: "start",
    value: function start(identifier) {
      if (!this.ele) {
        return function () {
          return void 0;
        };
      }

      var removeEffect = this.type === 'animation' ? this.startAnimation(this.ele, identifier) : this.startTransition(this.ele, identifier);
      return removeEffect;
    }
  }, {
    key: "setAnimationPlayState",
    value: function setAnimationPlayState(paused) {
      if (!this.ele) {
        return;
      }

      if (paused) {
        var _iterator = _createForOfIteratorHelper(animationPlayStateKeys),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var styleKey = _step.value;
            this.ele.style[styleKey] = 'paused';
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        var _iterator2 = _createForOfIteratorHelper(animationPlayStateKeys),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _styleKey = _step2.value;
            this.ele.style[_styleKey] = '';
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "startAnimation",
    value: function startAnimation(ele, identifier) {
      var _this2 = this;

      var validTarget = this.validTarget;
      var validKeyframes = this.validKeyframes;
      var activeClassName = this.activeClassName || '';
      var presetClassName = this.presetClassName || '';
      var meta = {
        animating: true,
        reseted: false,
        timeoutId: null
      };
      var timeSource = validTarget && validTarget instanceof HTMLElement ? validTarget : ele;
      this.setAnimationPlayState(true);
      addClass(ele, "".concat(presetClassName, " ").concat(activeClassName));
      var animationRange = this.getTimeRange(getAnimationValues(timeSource));

      var handler = function handler(event) {
        if (validTarget !== undefined && validTarget !== event.target) {
          return;
        }

        if (!meta.animating || meta.reseted) {
          return;
        }

        if (isValidKeyframe(validKeyframes, animationRange, event)) {
          AnimateEvents.removeAnimationEndListener(ele, handler);
          removeClass(ele, "".concat(presetClassName, " ").concat(activeClassName));
          meta.timeoutId && clearTimeout(meta.timeoutId);
          Object.assign(meta, {
            animating: false,
            reseted: true,
            timeoutId: null
          });

          _this2.emit('animate-end', identifier, false);
        }
      };

      AnimateEvents.addAnimationEndListener(ele, handler);
      this.emit('animate-ready', identifier);
      this.setAnimationPlayState(false);
      this.emit('animate-start', identifier);

      var reset = function reset() {
        if (!meta.reseted) {
          AnimateEvents.removeAnimationEndListener(ele, handler);
          removeClass(ele, "".concat(presetClassName, " ").concat(activeClassName));
          meta.timeoutId && clearTimeout(meta.timeoutId);
          Object.assign(meta, {
            reseted: true,
            timeoutId: null
          });

          _this2.emit('animate-end', identifier, meta.animating);
        }
      };

      if (this.timeout !== false) {
        var timeout = this.timeout !== true ? this.timeout : this.maxTimeCost * 1000 + 300;
        meta.timeoutId = window.setTimeout(reset, timeout);
      }

      return reset;
    }
  }, {
    key: "startTransition",
    value: function startTransition(ele, identifier) {
      var _this3 = this;

      var validTarget = this.validTarget;
      var validProperty = this.validProperty;
      var activeClassName = this.activeClassName || '';
      var presetClassName = this.presetClassName || '';
      var meta = {
        animating: true,
        reseted: false,
        timeoutId: null
      };
      var timeSource = validTarget && validTarget instanceof HTMLElement ? validTarget : ele;
      addClass(ele, presetClassName);
      var transitionRange = this.getTimeRange(getTransitionValues(timeSource));

      var handler = function handler(event) {
        if (validTarget !== undefined && validTarget !== event.target) {
          return;
        }

        if (!meta.animating || meta.reseted) {
          return;
        }

        if (isValidProperty(validProperty, transitionRange, event)) {
          AnimateEvents.removeTransitionEndListener(ele, handler);
          removeClass(ele, "".concat(presetClassName, " ").concat(activeClassName));
          meta.timeoutId && clearTimeout(meta.timeoutId);
          Object.assign(meta, {
            animating: false,
            reseted: true,
            timeoutId: null
          });

          _this3.emit('animate-end', identifier, false);
        }
      };

      AnimateEvents.addTransitionEndListener(ele, handler);
      this.emit('animate-ready', identifier);
      addClass(ele, activeClassName);
      this.emit('animate-start', identifier);

      var reset = function reset() {
        if (!meta.reseted) {
          AnimateEvents.removeTransitionEndListener(ele, handler);
          removeClass(ele, "".concat(presetClassName, " ").concat(activeClassName));
          meta.timeoutId && clearTimeout(meta.timeoutId);
          Object.assign(meta, {
            reseted: true,
            timeoutId: null
          });

          _this3.emit('animate-end', identifier, meta.animating);
        }
      };

      if (this.timeout !== false) {
        var timeout = this.timeout !== true ? this.timeout : this.maxTimeCost * 1000 + 300;
        meta.timeoutId = window.setTimeout(reset, timeout);
      }

      return reset;
    }
  }, {
    key: "getTimeRange",
    value: function getTimeRange(values) {
      var _this4 = this;

      this.maxTimeCost = Infinity;
      return values.reduce(function (prev, curr) {
        var currTimeCost = _this4.getTimeCost(curr);

        if (!prev) {
          _this4.maxTimeCost = currTimeCost;
          return [curr, curr];
        }

        if (_this4.getTimeCost(prev[0]) > currTimeCost) {
          prev[0] = curr;
        } else if (_this4.getTimeCost(prev[1]) < currTimeCost) {
          prev[1] = curr;
          _this4.maxTimeCost = currTimeCost;
        }
      }, undefined);
    }
  }, {
    key: "getTimeCost",
    value: function getTimeCost(value) {
      var times = 'iterationCount' in value ? value.iterationCount : 1;
      return value.delay + value.duration * times;
    }
  }]);

  return Animation;
}(Emitter);

function isValidKeyframe() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var valueRange = arguments.length > 1 ? arguments[1] : undefined;
  var event = arguments.length > 2 ? arguments[2] : undefined;

  switch (_typeof(option)) {
    case 'function':
      return option(event.animationName, event);

    case 'string':
      return event.animationName === option;
  }

  if (!valueRange) {
    return false;
  }

  return option ? event.animationName === valueRange[0].keyframes : event.animationName === valueRange[1].keyframes;
}

function isValidProperty() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var valueRange = arguments.length > 1 ? arguments[1] : undefined;
  var event = arguments.length > 2 ? arguments[2] : undefined;

  switch (_typeof(option)) {
    case 'function':
      return option(event.propertyName, event);

    case 'string':
      return event.propertyName === option;
  }

  if (!valueRange) {
    return false;
  }

  return option ? event.propertyName === valueRange[0].property : event.propertyName === valueRange[1].property;
}